/* Keep Shopify's section containers in their saved positions. Only the video
   contents move, so editor insertion/reordering cannot relocate the carousel. */
(function () {
  'use strict';
  if (window.kiiveVideoCarouselLoaded) return;
  window.kiiveVideoCarouselLoaded = true;
  var mobile = window.matchMedia('(max-width: 767px)');
  var groups = [];
  var refreshFrame = 0;
  var observer;

  function frameOrigin(frame) {
    try { return new URL(frame.src).origin; } catch (_) { return ''; }
  }
  function command(frame, func, args) {
    var origin = frameOrigin(frame);
    if (origin !== 'https://www.youtube.com') return;
    if (frame.contentWindow) frame.contentWindow.postMessage(JSON.stringify({event: 'command', func: func, args: args || []}), origin);
  }
  function pauseSlide(slide) {
    slide.querySelectorAll('iframe[src*="youtube.com/embed/"]').forEach(function (frame) { command(frame, 'pauseVideo'); });
  }
  function pauseOthers(source) {
    document.querySelectorAll('[data-kv-video-group]').forEach(function (slide) {
      if (slide !== source) pauseSlide(slide);
    });
  }
  function videoActive(slide) {
    pauseOthers(slide);
    // Legacy predates the shared audio-active event. Use its existing public
    // stop method; paired scheduling and all engine state stay in the player.
    var players = window.KiiveAW && window.KiiveAW.instances;
    if (players) players.forEach(function (player) {
      if (!player.consoleV2 && player.isPlaying) player.stop();
    });
    document.dispatchEvent(new CustomEvent('kiive:audio-active', {detail: {source: slide}}));
  }
  function listen(frame) {
    var origin = frameOrigin(frame);
    if (origin === 'https://www.youtube.com' && frame.contentWindow) {
      frame.contentWindow.postMessage(JSON.stringify({event: 'listening', id: frame.id || 'kiive-video'}), origin);
      command(frame, 'addEventListener', ['onStateChange']);
    }
  }
  // Capture load handles lazy and click-to-play frames without polling.
  document.addEventListener('load', function (event) {
    var frame = event.target;
    if (frame.tagName === 'IFRAME' && frame.closest('[data-kv-video-group]')) listen(frame);
  }, true);
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.youtube.com') return;
    var data;
    try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch (_) { return; }
    if (!data || !['onReady', 'onStateChange'].includes(data.event)) return;
    var frame = Array.from(document.querySelectorAll('[data-kv-video-group] iframe')).find(function (item) { return item.contentWindow === event.source; });
    if (!frame) return;
    if (data.event === 'onReady') { command(frame, 'addEventListener', ['onStateChange']); return; }
    if (data.info !== 1) return;
    var slide = frame.closest('[data-kv-video-group]');
    videoActive(slide);
  });
  document.addEventListener('kiive:audio-active', function (event) { pauseOthers(event.detail && event.detail.source); });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-kiive-audiowidget][data-player-style="legacy"] [data-kiive-aw-play]')) pauseOthers(null);
    var facade = event.target.closest('[data-kv-video-group] [data-kv-facade]');
    if (!facade) return;
    var slide = facade.closest('[data-kv-video-group]');
    videoActive(slide);
  }, true);

  function mount(sections, anchor, label, heading) {
    var contents = sections.map(function (section) { return section.querySelector('[data-kv-video-group-id]'); });
    var wrapper = document.createElement('section');
    wrapper.className = 'kv-video-carousel';
    wrapper.setAttribute('aria-label', label + ' videos');
    wrapper.setAttribute('aria-roledescription', 'carousel');
    var track = document.createElement('div');
    track.className = 'kv-video-carousel__track';
    track.id = 'kv-video-track-' + anchor.id;
    var nav = document.createElement('div');
    nav.className = 'kv-video-carousel__nav';
    var prev = document.createElement('button'), next = document.createElement('button'), status = document.createElement('span');
    prev.type = next.type = 'button'; prev.textContent = '←'; next.textContent = '→';
    prev.setAttribute('aria-label', 'Previous video'); next.setAttribute('aria-label', 'Next video');
    prev.setAttribute('aria-controls', track.id); next.setAttribute('aria-controls', track.id);
    status.className = 'kv-video-carousel__status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.setAttribute('aria-atomic', 'true');
    nav.append(prev, status, next); wrapper.append(track, nav);
    if (heading) heading.after(wrapper); else anchor.before(wrapper);
    var slides = contents.map(function (content, index) {
      var slide = document.createElement('div');
      slide.className = 'kv-video-carousel__slide';
      sections[index].setAttribute('data-kv-carousel-placeholder', '');
      slide.append(content); track.append(slide);
      slide.setAttribute('role', 'group'); slide.setAttribute('aria-roledescription', 'slide'); slide.setAttribute('aria-label', 'Video ' + (index + 1) + ' of ' + contents.length);
      return slide;
    });
    var active = -1, raf = 0;
    function update() {
      raf = 0;
      var left = track.getBoundingClientRect().left + 16;
      var closest = slides.reduce(function (best, slide, index) { return Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? index : best; }, 0);
      if (closest !== active) {
        slides.forEach(function (slide, index) { if (index !== closest) pauseSlide(slide); });
        active = closest; status.textContent = 'Video ' + (active + 1) + ' of ' + slides.length;
      }
      prev.disabled = active === 0; next.disabled = active === slides.length - 1;
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
    function go(index) {
      var slide = slides[index]; if (!slide) return;
      track.scrollTo({left: track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left - 16, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    prev.addEventListener('click', function () { go(active - 1); });
    next.addEventListener('click', function () { go(active + 1); });
    track.addEventListener('scroll', onScroll, {passive: true});
    update();
    groups.push(function (unloading) {
      cancelAnimationFrame(raf); track.removeEventListener('scroll', onScroll);
      sections.forEach(function (section, index) {
        pauseSlide(slides[index]); section.removeAttribute('data-kv-carousel-placeholder');
        // A load event may have replaced this section. Never restore stale
        // content over its fresh replacement or resurrect an unloaded section.
        if (section !== unloading && section.isConnected && !section.querySelector('[data-kv-video-group-id]')) section.append(contents[index]);
      }); wrapper.remove();
    });
  }
  function refresh() {
    groups.forEach(function (destroy) { destroy(); }); groups = [];
    if (!mobile.matches) return;
    var sections = Array.from(new Set(Array.from(document.querySelectorAll('[data-kv-video-group-id]')).map(function (node) { return node.closest('.shopify-section'); }))).filter(function (section) {
      return section && !section.closest('.kv-video-carousel');
    });
    var used = new Set();
    sections.forEach(function (start) {
      if (!start || used.has(start)) return;
      var content = start.querySelector('[data-kv-video-group-id]');
      var group = content.getAttribute('data-kv-video-group-id');
      var anchorId = content.getAttribute('data-kv-video-anchor');
      var headingMode = content.getAttribute('data-kv-video-group-mode') === 'heading';
      var siblings = Array.from(start.parentNode.children);
      var heading, boundary;
      if (headingMode) {
        var labelKey = videoKey(content.getAttribute('data-kv-video-group'));
        heading = siblings.find(function (section) {
          var title = section.querySelector('.rich-text .h1, .rich-text .h2, .rich-text h1, .rich-text h2');
          return title && videoKey(title.textContent) === labelKey;
        });
        if (!heading) return;
        boundary = siblings.slice(siblings.indexOf(heading) + 1).find(function (section) {
          return section.querySelector('.rich-text .h1, .rich-text .h2, .rich-text h1, .rich-text h2');
        });
      }
      var anchor = headingMode ? null : sections.find(function (section) { return section.parentNode === start.parentNode && section.id.endsWith('__' + anchorId); });
      if (!group || (!headingMode && (!anchor || !anchorId))) return;
      // Automatic groups belong to the heading's content area, not every
      // matching label on the page. Unrelated intervening sections are allowed.
      // Explicit enrollment remains available for intentionally nonadjacent groups.
      var slides = sections.filter(function (section) {
        return section && section.parentNode === start.parentNode &&
          section.querySelector('[data-kv-video-group-id]') &&
          section.querySelector('[data-kv-video-group-id]').getAttribute('data-kv-video-group-id') === group &&
          section.querySelector('[data-kv-video-group-id]').getAttribute('data-kv-video-group-mode') === content.getAttribute('data-kv-video-group-mode') &&
          (headingMode ? siblings.indexOf(section) > siblings.indexOf(heading) && (!boundary || siblings.indexOf(section) < siblings.indexOf(boundary)) : section.querySelector('[data-kv-video-group-id]').getAttribute('data-kv-video-anchor') === anchorId);
      });
      slides.forEach(function (slide) { used.add(slide); });
      if (headingMode) anchor = slides[0];
      if (slides.length > 1 && slides.includes(anchor)) mount(slides, anchor, anchor.querySelector('[data-kv-video-group-id]').getAttribute('data-kv-video-group'), heading);
    });
    document.querySelectorAll('[data-kv-video-group] iframe').forEach(listen);
    // Ignore our own moves; observe only subsequent editor DOM replacements.
    if (observer) observer.takeRecords();
  }
  function videoKey(value) { return (value || '').toLowerCase().replace(/^see\s+|\s+in\s+action\s*$/g, '').replace(/[^a-z0-9]/g, ''); }
  function scheduleRefresh() { cancelAnimationFrame(refreshFrame); refreshFrame = requestAnimationFrame(refresh); }
  mobile.addEventListener('change', scheduleRefresh);
  document.addEventListener('shopify:section:unload', function (event) { groups.forEach(function (destroy) { destroy(event.target); }); groups = []; scheduleRefresh(); });
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:section:reorder', scheduleRefresh);
  function init() {
    if (window.Shopify && window.Shopify.designMode && window.MutationObserver) {
      observer = new MutationObserver(function (records) {
        if (records.some(function (record) {
          return record.target.matches && (record.target.matches('main, .shopify-section') || Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) { return node.nodeType === 1 && node.matches('.shopify-section'); }));
        })) scheduleRefresh();
      });
      observer.observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
    }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
